var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.375 10.8972C0.375 5.14736 5.17985 0.5 10.9918 0.5C16.8201 0.5 21.625 5.14736 21.625 10.8972C21.625 13.7946 20.5713 16.4845 18.8369 18.7645C16.9235 21.2794 14.5652 23.4706 11.9107 25.1905C11.3031 25.588 10.7548 25.618 10.0881 25.1905C7.41842 23.4706 5.06011 21.2794 3.16313 18.7645C1.42748 16.4845 0.375 13.7946 0.375 10.8972ZM7.49292 11.2206C7.49292 13.1468 9.06471 14.6618 10.9919 14.6618C12.9204 14.6618 14.5073 13.1468 14.5073 11.2206C14.5073 9.30941 12.9204 7.7207 10.9919 7.7207C9.06471 7.7207 7.49292 9.30941 7.49292 11.2206Z",
    fill: "#FF384E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.3a2ce5bdda76856fb528a7b51340a044.svg";
export { ForwardRef as ReactComponent };